// removed by extract-text-webpack-plugin
module.exports = {"breadcrumbs":"sotxjpDzPaRzCX2tTIdRQ","frame":"RtmEMLRXzICtPHNj-FOTE"};


//////////////////
// WEBPACK FOOTER
// ./src/css/components/breadcrumbs.css
// module id = 340
// module chunks = 0